var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1483_42558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95 2.12001C5.29417 2.03945 5.64653 1.99918 6 2.00001C9.5 2.00001 11.5 6.00001 11.5 6.00001C11.1965 6.56782 10.8345 7.10238 10.42 7.59501M7.06 7.06001C6.92268 7.20739 6.75707 7.32559 6.57308 7.40757C6.38908 7.48956 6.19045 7.53364 5.98905 7.5372C5.78764 7.54075 5.58758 7.5037 5.4008 7.42826C5.21403 7.35282 5.04436 7.24053 4.90192 7.09809C4.75949 6.95565 4.6472 6.78598 4.57175 6.59921C4.49631 6.41243 4.45926 6.21237 4.46282 6.01097C4.46637 5.80956 4.51045 5.61094 4.59244 5.42694C4.67442 5.24294 4.79263 5.07734 4.94 4.94001M8.97 8.97001C8.1153 9.62151 7.07455 9.98244 6 10C2.5 10 0.5 6.00001 0.5 6.00001C1.12194 4.84096 1.98457 3.82832 3.03 3.03001L8.97 8.97001Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5L11.5 11.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1483_42558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.15c4e40ea88383fcd365f82903e7a8d2.svg";
export { ForwardRef as ReactComponent };